import { useTranslation } from 'react-i18next'
import { ControlSplit } from '@fs/zion-icon'
import { useImageOrganizeActions, useImageOrganizeModes } from '../../../views/imageBrowse/hooks'

export default function useUpdateDividersHoverButtonProps() {
  const [t] = useTranslation()
  const { addNewDivider } = useImageOrganizeActions()
  const { isDivideMode } = useImageOrganizeModes()
  return isDivideMode
    ? {
        Icon: ControlSplit,
        text: t('ImageBrowserViewer.hoverButtonText', 'End Item'),
        onClick: addNewDivider,
        linkName: 'add-new-divider-button',
      }
    : undefined
}
